// extracted by mini-css-extract-plugin
export default {"project-section":"Projects_project-section__eiSol"};